import {getPayments} from "@/api/payment";

const state = {
    history: {
        data: [],
        has_more: false,
        current_page: 1,
        starting_after: null,
    }
}

const getters = {
    history: state => state.history.data,
    has_more: state => state.history.has_more,
    current_page: state => state.history.current_page,
}

const mutations = {
    LOAD_PAYMENT_HISTORY: (state, history) => {
        state.history.has_more = history.meta.current_page < history.meta.last_page;
        state.history.current_page = history.meta.current_page;
        if (history.data.length > 0) {
            state.history.starting_after = history.data[history.data.length - 1].id;
        }

        //create or attach new data
        if (state.history.data.length === 0) {
            state.history.data = history.data;
        } else {
            state.history.data = state.history.data.concat(history.data);
        }
    },

    CLEAR_PAYMENT_HISTORY: (state) => {
        state.history.data = [];
        state.history.has_more = false;
        state.history.starting_after = null;
    }
}

const actions = {
    clearState({commit}) {
        commit('CLEAR_PAYMENT_HISTORY');
    },

    getHistory({commit, state}, page = 1) {
        return new Promise((resolve, reject) => {
            getPayments(page, state.history.starting_after)
                .then(response => {
                    commit('LOAD_PAYMENT_HISTORY', response)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
